// extracted by mini-css-extract-plugin
export default {"FullViewPage":"TaskFullView_FullViewPage__h6mQ9","breadcrumb":"TaskFullView_breadcrumb__J3S78"};